import { interact, URLS } from "fire-wind-water";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: interact.isMobile ? "WapIndex" : "PcIndex",
    component: () =>
      interact.isMobile
        ? import("../views/wap/Form.vue")
        : import("../views/pc/Form.vue"),
  },
  {
    path: "/pc_index",
    name: "PcIndex",
    component: () => import("../views/pc/Form.vue"),
  },
  {
    path: "/pcNew_index",
    name: "PcIndex",
    component: () => import("../views/pc/FormNew.vue"),
  },
  {
    path: "/wap_index",
    name: "WapIndex",
    component: () => import("../views/wap/Form.vue"),
  },
  {
    path: "/wapNew_index",
    name: "WapIndex",
    component: () => import("../views/wap/FormNew.vue"),
  },
  {
    path: "/pc_success",
    name: "PcSuccess",
    component: () => import("../views/pc/Success.vue"),
  },
  {
    path: "/pcNew_success",
    name: "PcSuccess",
    component: () => import("../views/pc/SuccessNew.vue"),
  },
  {
    path: "/wap_success",
    name: "WapSuccess",
    component: () => import("../views/wap/Success.vue"),
  },
  {
    path: "/wapNew_success",
    name: "WapSuccess",
    component: () => import("../views/wap/SuccessNew.vue"),
  },
  {
    path: "/pc_verify",
    name: "PcVerify",
    component: () => import("../views/pc/Verify.vue"),
  },
  {
    path: "/pcNew_verify",
    name: "PcVerify",
    component: () => import("../views/pc/VerifyNew.vue"),
  },
  {
    path: "/wap_verify",
    name: "WapVerify",
    component: () => import("../views/wap/Verify.vue"),
    props: (route) => ({
      customFormId: route.query.customFormId,
      linkId: route.query.linkId,
      configId: route.query.configId,
    }),
  },
  {
    path: "/wapNew_verify",
    name: "WapVerify",
    component: () => import("../views/wap/VerifyNew.vue"),
    props: (route) => ({
      customFormId: route.query.customFormId,
      linkId: route.query.linkId,
      configId: route.query.configId,
    }),
  },
];

const router = new VueRouter({
  //mode: "history",
  routes,
});

// 匹配当前环境 路由重定向
if (!URLS.getURL("isSetting")) {
  router.beforeEach((to, from, next) => {
    if (interact.isMobile && to.path.includes("pc")) {
      next({ path: to.path.replace("pc", "wap"), query: { ...to.query } });
    }
    if (!interact.isMobile && to.path.includes("wap")) {
      next({ path: to.path.replace("wap", "pc"), query: { ...to.query } });
    }
    next();
  });
}

export default router;
